import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from "./app.component";

// NgRx
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
// import { StoreDevtoolsModule } from "@ngrx/store-devtools";

// Core & Shared
import {CoreModule} from "@core/core.module";
import {SharedModule} from "@shared/shared.module";

// JWT Interceptor

// Material
import {MatMenuModule} from "@angular/material/menu";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {appReducer} from "./store/app.reducer";
import {AuthEffects} from "./store/auth/auth.effects";
import {AccountEffects} from "./store/account/account.effects";
import {GroupEffects} from "./store/group/group.effects";
import { DeviceEffects } from './store/device/device.effects';
import { RestrictionEffects } from './store/restriction/restriction.effects';
import { ChildDeactivationEffects } from './store/child-deactivation/child-deactivation.effects';
import { PupilLinkEffects } from './store/pupil-link/pupil-link.effects';
import { PupilDuplicateEffects } from './store/pupil-duplicate/pupil-duplicate.effects';
import { WondeSyncEffects } from './store/wonde-sync/wonde-sync.effects';
import { SchoolCalendarEffects } from './store/school-calendar/school-calendar.effects';
import { LandingComponent } from './features/auth/pages/landing/landing.component';
import { ReleaseNotesComponent } from './features/release-notes/release-notes.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    ReleaseNotesComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    StoreModule.forRoot(appReducer),
    EffectsModule.forRoot([AuthEffects, AccountEffects, GroupEffects, DeviceEffects, RestrictionEffects, PupilLinkEffects, PupilDuplicateEffects,
      WondeSyncEffects, ChildDeactivationEffects, SchoolCalendarEffects])
  ],
  providers: [
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}